import { getAuth, signOut } from "firebase/auth"
import { useContext, useEffect, useState } from "react";
import { ProfileContext } from "./contexts/profileContext";
import { Link } from "react-router-dom";

export default function Navbar() {
    const { userProfile, updateProfile } = useContext(ProfileContext);
    async function handleSignOut() {
        const auth = getAuth();
        await signOut(auth);    
        updateProfile(null);
        localStorage.removeItem('token');
    }


    return (
        <header class="text-gray-600 body-font">
            <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
                <Link class="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0" to="/">
                    <svg width="50" height="52" viewBox="0 0 50 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="25" cy="25" r="25" fill="#3A84F4"/>
                    <path d="M9.31179 29H7.34304L10.9276 18.8182H13.2045L16.794 29H14.8253L12.1058 20.9062H12.0263L9.31179 29ZM9.37642 25.0078H14.7457V26.4893H9.37642V25.0078ZM23.9444 15.5369V32.2812H22.274V15.5369H23.9444ZM38.7678 20.236L40.5598 20.754C38.7958 25.794 35.5338 28.734 30.5218 30.302C30.3258 29.882 29.7938 29.07 29.4578 28.664C34.3018 27.39 37.3118 24.8 38.7678 20.236ZM33.3638 20.348C34.7778 24.492 37.8018 27.474 42.7858 28.594C42.3798 28.986 41.8338 29.784 41.5678 30.274C36.3178 28.902 33.4338 25.696 31.6838 20.852L33.3638 20.348ZM29.7098 19.326H42.5338V20.978H29.7098V19.326ZM35.2118 17.114H36.9478V20.334H35.2118V17.114Z" fill="white"/>
                    </svg>

                    <span class="ml-3 text-xl">Lingologue</span>
                    {userProfile && <span class="inline-block py-1 px-2 rounded bg-blue-50 text-blue-500 text-xs font-medium tracking-widest ml-4">{userProfile.isPaid ? 'PRO' : 'Basic Plan'}</span>}

                </Link>
                <nav class="md:ml-auto flex flex-wrap items-center text-base justify-center">
                    <Link to="/practice" className="mr-5 hover:text-gray-900">Practice</Link>
                    
                    {
                        userProfile && !userProfile.isPaid && <Link to="/payment" className="mr-5 hover:text-gray-900 text-blue-500">Buy Pro</Link>
                    }
                </nav>

                {
                    userProfile ? (
                        <button class="inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0" onClick={handleSignOut}>
                            Log Out
                        </button>
                    ) : (
                        <Link to="/signin">
                        <button class="inline-flex items-center text-white bg-blue-500 border-0 py-1 px-3 focus:outline-none hover:bg-blue-600 rounded text-base mt-4 md:mt-0 mr-5">
                            Log In
                        </button>
                        </Link>
                        
                    )
                }

            </div>
        </header>
    )
}